import { fetchPOST } from './fetchHelper';

export async function fetchGeoApi(location) {
  return fetchPOST(
    `https://catalog.api.2gis.ru/2.0/transport/station/search?key=rupshg5251&q=${encodeURIComponent(
      location
    )}&region_id=32`,
    {}
  );
}

export async function fetchRoutesApi(body) {
  return fetchPOST(
    `https://catalog.api.2gis.ru/ctx/2.0/moscow?key=rupshg5251`,
    body
  );
}
